import { directions } from "@/mocks/mayiBaoliao";

const anchors = [
  { href: "#hot", label: "今日热榜" },
  { href: "#live", label: "实况快讯" },
  { href: "#guides", label: "五大方向" },
  { href: "#checklist", label: "避坑清单" },
  { href: "#board", label: "数据小报" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-200/70 text-foreground-800">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6">
        <div className="flex flex-col gap-8 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500">
                <i className="ri-sparkling-2-line text-lg text-background-50" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">五一爆料</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              汇总景区现场、游客见闻、酒店踩雷与交通拥堵实况，揭露旅游乱象，让每一次出行都少踩坑。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3">
            <div>
              <p className="text-sm font-semibold text-foreground-950">频道</p>
              <ul className="mt-3 space-y-2 text-sm">
                {anchors.map((a) => (
                  <li key={a.href}>
                    <a href={a.href} className="text-foreground-600 transition hover:text-foreground-950">
                      {a.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-950">方向</p>
              <ul className="mt-3 space-y-2 text-sm">
                {directions.map((d) => (
                  <li key={d.id}>
                    <a href="#guides" className="text-foreground-600 transition hover:text-foreground-950">
                      {d.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <p className="text-sm font-semibold text-foreground-950">建议</p>
              <ul className="mt-3 space-y-2 text-sm text-foreground-600">
                <li>投稿 / 线索可发往官方渠道</li>
                <li>紧急求助请第一时间报警</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            本站内容来自现场投稿与实况整理，仅供出行参考，请以景区、交通等官方发布为准。
          </p>
          <a href="#top" className="flex items-center gap-1 whitespace-nowrap text-xs font-medium text-foreground-600 transition hover:text-foreground-950">
            回到顶部
            <i className="ri-arrow-up-line text-xs" />
          </a>
        </div>
      </div>
    </footer>
  );
}